import React from "react"
import ReactDOM from "react-dom"
import { AnimatePresence } from "framer-motion"
import { TransactionUpdatesHeader } from "src/frontend/components/OS/Applications/Shared/Accounting/BulkActions/TransactionUpdatesHeader"
import { useTransactionUpdatesHeaderRoot } from "src/frontend/components/Shared/Transactions/Updates/Headers/useTransactionUpdatesHeaderRoot"
import { useTransactionsUpdates } from "src/frontend/components/Shared/Transactions/Updates/TransactionsUpdatesContext"

export const TransactionsUpdatesHeader: React.FC = () => {
  const root = useTransactionUpdatesHeaderRoot()
  const { updating, isUpdatingInline, transactionUpdates, applyTransactionUpdates, clearUpdates } =
    useTransactionsUpdates()

  return ReactDOM.createPortal(
    <AnimatePresence>
      {isUpdatingInline && (
        <TransactionUpdatesHeader
          updates={transactionUpdates}
          onCancel={clearUpdates}
          onUpdate={applyTransactionUpdates}
          disabled={updating}
        />
      )}
    </AnimatePresence>,
    root
  )
}
